module.exports = __webpack_public_path__ + "static/media/view6.f94f7100.jpg";